module.exports = __webpack_public_path__ + "img/member-avatar.04b4fa05.jpg";